// Views
import companyDetail from './companyDetail';
import jobdetail from './jobdetail';
import findjobs from './findjobs';
import findcompanies from './findcompanies';
import mypage from './mypage';
import spotlight from './spotlight';
import emailverification from './emailverification';
import recoverpassword from './recoverpassword';
import recoveruser from './recoveruser';
import favorites from './favorites';
import tests from './tests';
import resourcesInternal from './resourcesInternal';
import calendar from './calendar';
import activateuser from './activateuser';
import vfair from './vfair';
import assessments from './assessments';
import userConsent from './userConsent';
import coursera from './coursera';
import account from './account';
import schoolevents from './schoolevents';
import studyProgram from './studyProgram';
import profile from './profile';

// Other
import general from './general';
import shared from './shared';
import components from './components';
import cts from './cts';
import errors from './errors';
import gptw from './gptw';
import chat from './chat';

export default {
    companyDetail,
    documents: {
        cv: {
            title: 'Documents',
            consent:
                'By uploading this document I hereby consent to the processing of the personal data in my document, to any company/organization on the Highered platform for the sole purpose of consideration of my skills and experience for professional opportunities.',
            cvs: 'CVs',
            uploadDocument: 'Upload document',
            documentUpload: 'Document upload',
            uploadCV: 'Upload CV',
            editCV: 'Edit CV',
            editDocument: 'Edit document',
            deleteCV: 'Delete CV',
            areYouSure: 'Are you sure you want to delete this document?',
            noCVs: 'Showcase your career achievements! Upload your CVs, cover letters, diplomas, and other documents related to your career. Let potential employers see your best work!',
            info: 'Showcase your career achievements! Upload your CVs, cover letters, diplomas, and other documents related to your career. Let potential employers see your best work!',
            setDefaultInfo:
                'Setting this CV as primary will make it the default document available for recruiters.',
            fileFormatInfo: 'Supported file formats are: pdf, doc, docx',
            wrongFileSizeHeader: 'File size is too large',
            wrongFIleSizeDescription: 'Maximum file size is 16MB',
        },
    },
    jobdetail,
    findjobs,
    findcompanies,
    mypage,
    spotlight,
    emailverification,
    recoverpassword,
    recoveruser,
    favorites,
    tests,
    calendar,
    resourcesInternal,
    activateuser,
    vfair,
    assessments,
    userConsent,
    coursera,
    account,
    schoolevents,
    studyProgram,
    profile,

    general,
    shared,
    components,
    cts,
    errors,
    gptw,
    chat,
};
